module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Create class","weaponsActionsCreateSuccess":"%{weaponsName} was successfully added to the database"},"no":{"dialogTitle":"Opprett klasse","weaponsActionsCreateSuccess":"%{weaponsName} ble lagt til i databasen"}}')
  delete Component.options._Ctor
}
